import {IIncident} from "../../../core/interfaces/incident";
import {BooleanForm} from "./BooleanForm";


export function HasExternalUsersForm (props: { editMode: boolean, newIncident: IIncident, onChange: (value: boolean | null, e: any) => void })
{
   return <BooleanForm {...props} header={"Fanns det externa personer involverade"} propertyName={"hasExternalUsers"}
                 property={props.newIncident.hasExternalUsers}/>
}
